require('particles.js');

if ($('#nightSky').length) {
	
	particlesJS("nightSky", {
		"particles": {
		"number": {
			"value": 355,
			"density": {
			"enable": true,
			"value_area": 789.1476416322727
			}
		},
		"color": {
			"value": "#ffffff"
		},
		"shape": {
			"type": "circle",
			"stroke": {
			"width": 0,
			"color": "#000000"
			},
			"polygon": {
			"nb_sides": 5
			},
		},
		"opacity": {
			"value": 0.48927153781200905,
			"random": false,
			"anim": {
			"enable": true,
			"speed": 0.2,
			"opacity_min": 0,
			"sync": false
			}
		},
		"size": {
			"value": 2,
			"random": true,
			"anim": {
			"enable": true,
			"speed": 2,
			"size_min": 0,
			"sync": false
			}
		},
		"line_linked": {
			"enable": false,
			"distance": 150,
			"color": "#ffffff",
			"opacity": 0.4,
			"width": 1
		},
		"move": {
			"enable": true,
			"speed": 0.2,
			"direction": "none",
			"random": true,
			"straight": false,
			"out_mode": "out",
			"bounce": false,
			"attract": {
			"enable": false,
			"rotateX": 600,
			"rotateY": 1200
			}
		}
		},
		"interactivity": {
		"detect_on": "canvas",
		"events": {
			"onhover": {
			"enable": true,
			"mode": "bubble"
			},
			"onclick": {
			"enable": true,
			"mode": "push"
			},
			"resize": true
		},
		"modes": {
			"grab": {
			"distance": 400,
			"line_linked": {
				"opacity": 1
			}
			},
			"bubble": {
			"distance": 83.91608391608392,
			"size": 1,
			"duration": 3,
			"opacity": 1,
			"speed": 3
			},
			"repulse": {
			"distance": 200,
			"duration": 0.4
			},
			"push": {
			"particles_nb": 4
			},
			"remove": {
			"particles_nb": 2
			}
		}
		},
		"retina_detect": true
	});
}


if ($('#nightSkyMobile').length) {
	particlesJS("nightSkyMobile", {
		"particles": {
		"number": {
			"value": 355,
			"density": {
			"enable": true,
			"value_area": 789.1476416322727
			}
		},
		"color": {
			"value": "#ffffff"
		},
		"shape": {
			"type": "circle",
			"stroke": {
			"width": 0,
			"color": "#000000"
			},
			"polygon": {
			"nb_sides": 5
			},
		},
		"opacity": {
			"value": 0.48927153781200905,
			"random": false,
			"anim": {
			"enable": true,
			"speed": 0.2,
			"opacity_min": 0,
			"sync": false
			}
		},
		"size": {
			"value": 2,
			"random": true,
			"anim": {
			"enable": true,
			"speed": 2,
			"size_min": 0,
			"sync": false
			}
		},
		"line_linked": {
			"enable": false,
			"distance": 150,
			"color": "#ffffff",
			"opacity": 0.4,
			"width": 1
		},
		"move": {
			"enable": true,
			"speed": 0.2,
			"direction": "none",
			"random": true,
			"straight": false,
			"out_mode": "out",
			"bounce": false,
			"attract": {
			"enable": false,
			"rotateX": 600,
			"rotateY": 1200
			}
		}
		},
		"interactivity": {
		"detect_on": "canvas",
		"events": {
			"onhover": {
			"enable": true,
			"mode": "bubble"
			},
			"onclick": {
			"enable": true,
			"mode": "push"
			},
			"resize": true
		},
		"modes": {
			"grab": {
			"distance": 400,
			"line_linked": {
				"opacity": 1
			}
			},
			"bubble": {
			"distance": 83.91608391608392,
			"size": 1,
			"duration": 3,
			"opacity": 1,
			"speed": 3
			},
			"repulse": {
			"distance": 200,
			"duration": 0.4
			},
			"push": {
			"particles_nb": 4
			},
			"remove": {
			"particles_nb": 2
			}
		}
		},
		"retina_detect": true
	});
}












if ($('#molecules').length) {
	particlesJS("molecules", 
	{
		"particles": {
			"number": {
				"value": 30,
				"density": {
					"enable": true,
					"value_area": 700
				}
			},
			"color": {
				"value": "#f6ab42"
			},
			"shape": {
				"type": "circle",
				"stroke": {
					"width": 1,
					"color": "#000000"
				},
				"polygon": {
					"nb_sides": 5
				},
				"image": {
					"src": "img/github.svg",
					"width": 100,
					"height": 100
				}
			},
			"opacity": {
				"value": 1,
				"random": false,
				"anim": {
					"enable": false,
					"speed": 1,
					"opacity_min": 0.1,
					"sync": false
				}
			},
			"size": {
				"value": 7,
				"random": true,
				"anim": {
					"enable": false,
					"speed": 40,
					"size_min": 7,
					"sync": false
				}
			},
			"line_linked": {
				"enable": true,
				"distance": 100,
				"color": "#161615",
				"opacity": 0.7,
				"width": 1
			},
			"move": {
				"enable": true,
				"speed": 0.6,
				"direction": "none",
				"random": false,
				"straight": false,
				"out_mode": "bounce",
				"bounce": false,
				"attract": {
					"enable": true,
					"rotateX": 600,
					"rotateY": 1200
				}
			}
		},
		"interactivity": {
			"detect_on": "canvas",
			"events": {
				"onhover": {
					"enable": false,
					"mode": "repulse"
				},
				"onclick": {
					"enable": false,
					"mode": "push"
				},
				"resize": true
			},
			"modes": {
				"grab": {
					"distance": 400,
					"line_linked": {
						"opacity": 1
					}
				},
				"bubble": {
					"distance": 400,
					"size": 40,
					"duration": 2,
					"opacity": 8,
					"speed": 3
				},
				"repulse": {
					"distance": 200,
					"duration": 0.4
				},
				"push": {
					"particles_nb": 4
				},
				"remove": {
					"particles_nb": 2
				}
			}
		},
		"retina_detect": true
	}
	);
}